import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ContentUnavailableMessageComponent } from './content-unavailable-message.component';

/** Full-page variant, shown at `/unavailable` when a deep link (URL) fails to load. */
@Component({
  selector: 'mtm-content-unavailable',
  standalone: true,
  imports: [ContentUnavailableMessageComponent],
  templateUrl: './content-unavailable.component.html',
  styleUrl: './content-unavailable.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentUnavailableComponent {
  private readonly router = inject(Router);
  private readonly location = inject(Location);

  protected goHome(): void {
    this.router.navigateByUrl('/');
  }

  protected goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.goHome();
    }
  }
}
